import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import BlockCollection from "./BlockCollection";
import Block from "./Block";
var _attributes = /*#__PURE__*/new WeakMap();
export default class PageFooterBlock extends Block {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [PageFooterBlock.sections_attribute_name]: BlockCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getSectionsAttributeName() {
    return this.sections_attribute_name;
  }
}
_defineProperty(PageFooterBlock, "NAME", 'page_footer_block');
_defineProperty(PageFooterBlock, "sections_attribute_name", 'sections');